import { render, staticRenderFns } from "./Car.vue?vue&type=template&id=1b7a4c10&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Car.vue"
export default component.exports